import React from 'react';

interface Props {
  title: string;
  description?: string;
  className?: string; // permite estilos adicionales si se necesita
}

const SectionHeader: React.FC<Props> = ({ title, description, className = '' }) => {
  return (
    <div className={`mb-4 ${className}`}>
      <h3 className="text-lg font-semibold text-black dark:text-white">
        {title}
      </h3>
      {description && (
        <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
          {description}
        </p>
      )}
    </div>
  );
};

export default SectionHeader;
